<template>
    <div>
        <div class="no-pd mar-t-10">
            <v-tabs
                v-model="tab"
                background-color="blue accent-2"
                color="lime accent-2"
                class="elevation-2"
                dark
                :grow="true"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab
                    v-for="i in tabs_name.length"
                    :key="i"
                    :href="`#tab-${i}`"
                    @click="change_tab(tabs_name[i - 1])"
                >
                    <v-icon class="mr-1" v-if="tabs_name[i - 1] === active_tab"
                        >mdi-checkbox-marked-circle</v-icon
                    >
                    {{ tabs_name[i - 1].title }}
                    <v-chip
                        small
                        class="ml-1"
                        color="orange"
                        v-if="tabs_name[i - 1].num_cases > 0"
                    >
                        {{ tabs_name[i - 1].num_cases }}
                    </v-chip>
                </v-tab>

                <v-tab-item
                    v-for="i in tabs_name.length"
                    :key="i"
                    :value="'tab-' + i"
                >
                    <v-card flat tile>
                        <v-card-text>
                            <div class="mar-t-10">
                                <span
                                    style="color: #e04646"
                                    v-if="
                                        tabs_name[i - 1].title == 'Incomplete'
                                    "
                                >
                                    <b
                                        >(หลังจาก order part และ แอดมินเปิด sub
                                        แล้วเคสจะหายไป)</b
                                    >
                                </span>
                                <v-carousel
                                    :continuous="true"
                                    :cycle="false"
                                    :show-arrows="false"
                                    light
                                    height="100%"
                                    hide-delimiter-background
                                    show-arrows-on-hover
                                >
                                    <v-carousel-item
                                        v-for="(row, index) in data_main"
                                        :key="index"
                                        height="100%"
                                    >
                                        <v-sheet height="100%" tile>
                                            <v-row class="ml-1 mr-1">
                                                <v-col cols="6">
                                                    <v-btn
                                                        v-if="
                                                            tabs_name[i - 1]
                                                                .title != 'PUR'
                                                        "
                                                        :color="
                                                            status_color[
                                                                row.status_color
                                                            ]
                                                        "
                                                        @click="
                                                            change_case(
                                                                row.maincase_id,
                                                                tabs_name[i - 1]
                                                                    .title,
                                                                row.case_id,
                                                                row.subcase,
                                                                row.product_group,
                                                                row.project_name,
                                                                row.warranty_type,
                                                                row.subcase_wonumber,
                                                                row
                                                            )
                                                        "
                                                        class="mr-1"
                                                        block
                                                    >
                                                        {{
                                                            row.case_id +
                                                                "-" +
                                                                row.subcase
                                                        }}
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        color="yellow darken-1"
                                                        class="mr-1"
                                                        block
                                                        @click="
                                                            change_case_picup(
                                                                row.maincase_id
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            row.case_id +
                                                                "-" +
                                                                row.subcase
                                                        }}
                                                    </v-btn>
                                                </v-col>

                                                <v-col
                                                    cols="6"
                                                    class="text-right mt-1"
                                                >
                                                    <v-icon color="primary">
                                                        mdi-timer
                                                    </v-icon>
                                                    {{ row.created_date }}
                                                </v-col>
                                                <v-col cols="12" class="mar-t-10" v-if="row.subcase_wonumber">
                                    <v-icon color="primary" class="mr-1"
                                        >mdi-package-variant</v-icon
                                    >
                                    <strong style="color: #455a64">{{
                                        row.subcase_wonumber
                                    }}</strong>
                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    class="mar-t-10"
                                                >
                                                    <v-icon color="primary"
                                                        >mdi-home-circle</v-icon
                                                    >
                                                    {{ row.site_name }}
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    class="mar-t-10"
                                                >
                                                    <v-icon
                                                        color="orange darken-3"
                                                        class="mr-1"
                                                        >mdi-home-map-marker</v-icon
                                                    >
                                                    <strong
                                                        style="color: #ef6c00"
                                                        >{{
                                                            row.site_address
                                                        }}</strong
                                                    >
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    class="mar-t-10"
                                                >
                                                    <v-icon color="primary"
                                                        >mdi-car-estate</v-icon
                                                    >
                                                    {{ row.case_title }}
                                                    <br
                                                        v-if="row.subcase_title"
                                                    />
                                                    <v-chip
                                                        v-if="row.subcase_title"
                                                        small
                                                        color="purple lighten-4"
                                                        >{{
                                                            row.subcase_title
                                                        }}</v-chip
                                                    >
                                                </v-col>
                                                <v-col
                                                    class="mar-t-10"
                                                    cols="12"
                                                    ><v-icon color="primary">
                                                        mdi-account-circle</v-icon
                                                    >
                                                    {{ row.customer_name }}
                                                </v-col>

                                                <v-col
                                                    class="mar-t-10"
                                                    cols="6"
                                                    v-for="phone in row.customer_tel"
                                                    :key="phone"
                                                >
                                                    <v-icon
                                                        style="color: #dbb20d"
                                                    >
                                                        mdi-whatsapp
                                                    </v-icon>
                                                    <a
                                                        style="
                                                            color: #dbb20d;
                                                            font-weight: bold;
                                                        "
                                                        :href="`tel:${phone}`"
                                                        class="ml-1"
                                                        >{{ phone }}</a
                                                    >
                                                </v-col>
                                                <v-col
                                                    class="mar-t-10"
                                                    cols="6"
                                                >
                                                    <v-icon color="primary"
                                                        >mdi-tag</v-icon
                                                    >
                                                    {{ row.product_serial }}
                                                </v-col>
                                                <v-col
                                                    class="mar-t-10"
                                                    cols="6"
                                                >
                                                    <v-icon color="primary"
                                                        >mdi-cellphone-link</v-icon
                                                    >
                                                    {{ row.product_no }}
                                                </v-col>
                                                <v-col
                                                    class="mar-t-10"
                                                    cols="12"
                                                >
                                                    <v-icon color="primary"
                                                        >mdi-gmail</v-icon
                                                    >
                                                    {{ row.customer_email }}
                                                </v-col>

                                                <v-col
                                                    class="mar-t-10"
                                                    cols="12"
                                                    v-for="(r,
                                                    index) in row.parts"
                                                    :key="index"
                                                >
                                                    <div
                                                        v-if="
                                                            r.status !=
                                                                'Back Order'
                                                        "
                                                    >
                                                        <v-icon
                                                            :style="
                                                                r.status ==
                                                                'Reserve'
                                                                    ? 'color:#D500F9; font-weight: bold;'
                                                                    : 'color:#0097A7; font-weight: bold;'
                                                            "
                                                            >mdi-pound</v-icon
                                                        >
                                                        <strong
                                                            :style="
                                                                r.status ==
                                                                'Reserve'
                                                                    ? 'color:#D500F9; font-weight: bold;'
                                                                    : 'color:#0097A7; font-weight: bold;'
                                                            "
                                                        >
                                                            <span
                                                                v-if="
                                                                    r.ponumber &&
                                                                        r.ponumber !==
                                                                            'null'
                                                                "
                                                                >{{
                                                                    r.ponumber +
                                                                        " / "
                                                                }}</span
                                                            >
                                                            {{
                                                                r.part_name +
                                                                    " - " +
                                                                    r.part_description
                                                            }}
                                                            <span class="ml-1">
                                                                {{
                                                                    "*" +
                                                                        r.status
                                                                }}
                                                            </span>
                                                        </strong>
                                                    </div>
                                                    <div v-else>
                                                        <v-icon color="primary"
                                                            >mdi-pound</v-icon
                                                        >
                                                        ให้เข้าตรวจสอบก่อนว่าใช้
                                                        Part หรือไม่
                                                        {{
                                                            r.part_name +
                                                                " - " +
                                                                r.part_description
                                                        }}
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-textarea
                                                        readonly
                                                        outlined
                                                        v-model="row.lognote"
                                                        background-color="#e6f3ff"
                                                        label="Log Note..."
                                                        rows="6"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                        </v-sheet>
                                    </v-carousel-item>
                                </v-carousel>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>

        <!-- Modal Close Case -->
        <v-dialog
            v-model="dialogCloseCase"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="back()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ show_case }}</v-toolbar-title>
                </v-toolbar>

                <v-form
                    method="post"
                    id="nativeForm"
                    v-model="valid"
                    v-for="(r, num) in data_close_case"
                    :key="num"
                >
                    <div v-if="active_tab.title != 'Upload Img Failed'">
                        <v-row justify="center">
                            <!-- START Kbank -->
                            <v-col cols="10" v-if="r.project_name === 'KBANK'"
                                ><b>New Toner</b></v-col
                            >
                            <v-col
                                v-if="r.project_name === 'KBANK'"
                                cols="5"
                                class="mar-t-10"
                            >
                                <v-text-field
                                    dense
                                    label="SN"
                                    v-model="form_1.sn"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                cols="10"
                                class="mar-t-10"
                                v-if="r.project_name === 'KBANK'"
                                ><b>Old Toner</b></v-col
                            >
                            <v-col
                                v-if="r.project_name === 'KBANK'"
                                cols="5"
                                class="mar-t-10"
                            >
                                <v-text-field
                                    dense
                                    label="%"
                                    v-model="form_1.persend"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                v-if="r.project_name === 'KBANK'"
                                cols="5"
                                class="mar-t-10"
                            >
                                <v-text-field
                                    dense
                                    label="Page Remaining"
                                    v-model="form_1.page_remaining"
                                ></v-text-field>
                            </v-col>
                            <v-col
                                v-if="r.project_name === 'KBANK'"
                                cols="10"
                                class="mar-t-10"
                            >
                                <v-text-field
                                    dense
                                    label="Page Printer with this support"
                                    v-model="form_1.page_printer"
                                ></v-text-field>
                            </v-col>
                            <!-- END Kbank -->
                        </v-row>

                        <v-row
                            justify="center"
                            class="mar-t-10"
                            v-for="(row_part, nums) in r.parts"
                            :key="nums"
                        >
                            <v-col cols="5" class="mt-7">
                                <v-chip color="warning" text-color="white">
                                    {{ row_part.part_name }}
                                </v-chip>
                            </v-col>
                            <v-col cols="5">
                                <v-select
                                    :items="
                                        row_part.status != 'Back Order'
                                            ? part_item
                                            : part_backorder_item
                                    "
                                    item-text="text"
                                    item-value="id"
                                    label="Status part"
                                    v-model="
                                        form_1.part[
                                            'P' + row_part.part_issue_id
                                        ]
                                    "
                                    :rules="part_issue_idR"
                                    required
                                ></v-select>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- v-if="case_team_name == 'NONHP'" -->
                    <v-row justify="center">
                        <v-col
                            cols="10"
                            v-if="
                                active_tab == 'Rejected' &&
                                    case_team_name == 'NONHP'
                            "
                        >
                            <v-chip color="lime accent-3"
                                ><b>ใช้ Part เพิ่มเติม</b></v-chip
                            >
                            <v-btn
                                class="ml-2"
                                color="lime accent-3"
                                fab
                                small
                                @click="open_add_part()"
                            >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </v-col>

                        <v-col
                            class="mar-t-15"
                            cols="10"
                            v-for="(row_data_case_part,
                            index_data_case_part) in form_1.case_part"
                            :key="index_data_case_part"
                        >
                            <v-chip color="lime accent-1" class="mr-1"
                                ><b
                                    >{{ index_data_case_part + 1 }}.{{
                                        row_data_case_part.singlepart
                                    }}</b
                                ></v-chip
                            >
                            <v-chip color="lime accent-1"
                                ><b>{{ row_data_case_part.status }}</b></v-chip
                            >
                        </v-col>
                    </v-row>

                    <v-row
                        justify="center"
                        class="mar-t-20"
                        v-if="active_tab.title != 'Upload Img Failed'"
                    >
                        <v-col cols="5" class="mt-3">
                            Time Start
                            <vue-timepicker
                                :rules="startR"
                                v-model="form_1.start"
                                class="mt-1"
                            ></vue-timepicker>
                        </v-col>

                        <v-col cols="5" class="mt-3">
                            Time Stop
                            <vue-timepicker
                                v-model="form_1.stop"
                                :rules="stopR"
                                class="mt-1"
                                :disabled="team_name == 'ONSITE'"
                            ></vue-timepicker>
                        </v-col>

                        <v-col cols="10" class="">
                            <v-text-field
                                label="Csono"
                                v-model="form_1.csono"
                                dense
                                :rules="csonoR"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="10" class="mar-t-10">
                            <!-- @keyup="uppercase(1)" -->
                            <v-textarea
                                outlined
                                label="Solution.."
                                background-color="#FFFF"
                                rows="3"
                                :rules="solutionR"
                                v-model="form_1.solution"
                            ></v-textarea>
                        </v-col>

                        <v-col cols="10" class="mar-t-30">
                            <v-text-field
                                dense
                                label="Email"
                                background-color="#FFFF"
                                v-model="form_1.email"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col
                            cols="12"
                            v-if="active_tab.title == 'Upload Img Failed'"
                        >
                            <h4>{{ active_tab.title }}</h4>
                        </v-col>
                        <v-col cols="6" class="mar-t-10">
                            <div
                                id="my-strictly-unique-vue-upload-multiple-image"
                                style="text-align: center"
                            >
                                <vue-upload-multiple-image
                                    @upload-success="uploadImageSuccess"
                                    @before-remove="beforeRemove"
                                    @edit-image="editImage"
                                    @data-change="dataChange"
                                    dragText="UPLOAD"
                                    browseText="CSO"
                                    primaryText="cso image"
                                    markIsPrimaryText="จัดลำดับรูปภาพ"
                                    idUpload="myIdUpload1"
                                    editUpload="myIdEdit1"
                                    :maxImage="20"
                                    :rules="myIdUpload1"
                                ></vue-upload-multiple-image>
                                <span
                                    class="text-color-red font-fix-13"
                                    v-if="chk_cso === true"
                                    >** CSO Upload is required</span
                                >
                            </div>
                        </v-col>

                        <v-col cols="6" class="text-center">
                            <div class="images" v-viewer="{ movable: false }">
                                <div
                                    v-for="(pic, num_pic) in r.cso"
                                    :key="num_pic"
                                >
                                    <img
                                        :src="url_pic + pic.file_id"
                                        class="image-cso"
                                    />
                                    <v-btn
                                        fab
                                        color="red accent-2"
                                        class="image-cso-btn"
                                        x-small
                                        @click="del_img('cso', pic.file_id)"
                                    >
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>

                        <v-col
                            cols="6"
                            v-if="
                                product_group != 'Printing' &&
                                    state_chk.project_name == 'CDAX'
                            "
                        >
                            <div id="2" style="text-align: center">
                                <vue-upload-multiple-image
                                    @upload-success="uploadImageSuccess2"
                                    @before-remove="beforeRemove2"
                                    @edit-image="editImage2"
                                    @data-change="dataChange2"
                                    dragText="UPLOAD"
                                    browseText="
                                                UEFI
                                            "
                                    primaryText="uefi image"
                                    markIsPrimaryText="จัดลำดับรูปภาพ"
                                    idUpload="myIdUpload2"
                                    editUpload="myIdEdit2"
                                    :maxImage="50"
                                ></vue-upload-multiple-image>
                            </div>
                        </v-col>

                        <v-col
                            cols="6"
                            class="text-center"
                            v-if="
                                product_group != 'Printing' &&
                                    state_chk.project_name == 'CDAX'
                            "
                        >
                            <div class="images" v-viewer="{ movable: false }">
                                <div
                                    v-for="(pic_uefi, num_pic_uefi) in r.uefi"
                                    :key="num_pic_uefi"
                                >
                                    <img
                                        :src="url_pic + pic_uefi.file_id"
                                        class="image-cso"
                                    />
                                    <v-btn
                                        fab
                                        color="red accent-2"
                                        class="image-cso-btn"
                                        x-small
                                        @click="
                                            del_img('uefi', pic_uefi.file_id)
                                        "
                                    >
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="6">
                            <div id="2" style="text-align: center">
                                <vue-upload-multiple-image
                                    @upload-success="uploadImageSuccess3"
                                    @before-remove="beforeRemove3"
                                    @edit-image="editImage3"
                                    @data-change="dataChange3"
                                    dragText="UPLOAD"
                                    browseText="ATTACH"
                                    primaryText="attach image"
                                    markIsPrimaryText="จัดลำดับรูปภาพ"
                                    idUpload="myIdUpload3"
                                    editUpload="myIdEdit3"
                                    :maxImage="50"
                                ></vue-upload-multiple-image>
                                <span
                                    class="text-color-red font-fix-13"
                                    v-if="chk_attach === true"
                                    >** ATTACH Upload is required</span
                                >
                            </div>
                        </v-col>

                        <v-col cols="6" class="text-center">
                            <div class="images" v-viewer="{ movable: false }">
                                <div
                                    v-for="(pic_attach,
                                    num_pic_attach) in r.attach"
                                    :key="num_pic_attach"
                                >
                                    <img
                                        :src="url_pic + pic_attach.file_id"
                                        class="image-cso"
                                    />
                                    <v-btn
                                        fab
                                        color="red accent-2"
                                        class="image-cso-btn"
                                        x-small
                                        @click="
                                            del_img(
                                                'attach',
                                                pic_attach.file_id
                                            )
                                        "
                                    >
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>

                        <v-col
                            cols="10"
                            class="mar-t-10"
                            v-if="active_tab.title == 'Upload Img Failed'"
                        >
                            <v-progress-linear
                                v-if="chk_save_data == true"
                                indeterminate
                                color="cyan"
                            ></v-progress-linear>
                            <v-btn
                                v-if="chk_save_data == false"
                                color="success"
                                block
                                @click="save_close_case_img()"
                                :disabled="!valid"
                                ><v-icon small class="mr-1"
                                    >mdi-content-save</v-icon
                                >
                                Save</v-btn
                            >
                        </v-col>

                        <v-col cols="10" class="mar-t-10" v-else>
                            <v-progress-linear
                                v-if="chk_save_data == true"
                                indeterminate
                                color="cyan"
                            ></v-progress-linear>
                            <v-btn
                                v-if="chk_save_data == false"
                                color="success"
                                block
                                @click="save_close_case()"
                                :disabled="!valid"
                                ><v-icon small class="mr-1"
                                    >mdi-content-save</v-icon
                                >
                                Save</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-dialog>

        <!-- Modal -->
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-form method="post" id="nativeForm" v-model="valid">
                        <v-card-title>
                            <span class="headline">Update Status Case.</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            dense
                                            outlined
                                            :items="['Complete', 'Incomplete']"
                                            label="Status"
                                            required
                                            v-model="form.status"
                                            :rules="statusR"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="mar-t-20 mb-1"
                                        v-if="form.status === 'Complete'"
                                    >
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                class="text-center"
                                            >
                                                ลูกค้าพึงพอใจกับการบริการครั้งนี้หรือไม่
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                class="text-center mar-t-20"
                                            >
                                                <img
                                                    :class="
                                                        form.customer_level ===
                                                        'L'
                                                            ? 'fix-png-a clik-cor red '
                                                            : 'fix-png-a'
                                                    "
                                                    src="../../../assets/all/sad.png"
                                                    @click="cick_cus('L')"
                                                />
                                                <img
                                                    class=""
                                                    :class="
                                                        form.customer_level ===
                                                        'M'
                                                            ? 'fix-png-a ml-2 mr-2 clik-cor yellow '
                                                            : 'fix-png-a ml-2 mr-2'
                                                    "
                                                    src="../../../assets/all/face.png"
                                                    @click="cick_cus('M')"
                                                />
                                                <img
                                                    :class="
                                                        form.customer_level ===
                                                        'H'
                                                            ? 'fix-png-a clik-cor teal accent-3'
                                                            : 'fix-png-a'
                                                    "
                                                    src="../../../assets/all/smile.png"
                                                    @click="cick_cus('H')"
                                                />
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                class="text-center mar-t-20"
                                                v-if="
                                                    chk_customer_level === true
                                                "
                                            >
                                                <span
                                                    class="text-color-red font-fix-13"
                                                    >** Customer level is
                                                    required</span
                                                >
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                v-if="
                                                    state_chk.project_name ===
                                                        'CDAX' &&
                                                        product_group ==
                                                            'Computing'
                                                "
                                            >
                                                <v-radio-group
                                                    v-model="form.uefi"
                                                    :rules="uefiR"
                                                    required
                                                    row
                                                >
                                                    <v-radio
                                                        label="มี UEFI"
                                                        value="Y"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ไม่มี UEFI"
                                                        value="N"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>

                                            <v-col cols="12" class="mar-t-10">
                                                <v-combobox
                                                    v-if="form.uefi === 'N'"
                                                    :items="[
                                                        'PND - Part detected โดยระบบไม่ได้ เช่น No Power',
                                                        'DHU - โปรแกรม diagnostic ค้าง หรือ ไม่สำเร็จ',
                                                        'PPR - พาร์ทที่เทส UEFI ผ่านแต่ยังต้องเปลี่ยนแปลง HDD เรื่องจากยังมีอาการอยู่',
                                                        'CNR - ลูกค้าไม่สะดวกให้เทส',
                                                    ]"
                                                    dense
                                                    outlined
                                                    label="ระบุ UEFI"
                                                    v-model="form.uefi_text"
                                                    :rules="uefi_textRR"
                                                ></v-combobox>
                                                <v-text-field
                                                    outlined
                                                    v-if="form.uefi === 'Y'"
                                                    dense
                                                    label="ระบุ UEFI"
                                                    v-model="form.uefi_text"
                                                    :maxlength="27"
                                                    :counter="27"
                                                    @keyup="checkfid_text()"
                                                    :rules="uefi_textR"
                                                    required
                                                ></v-text-field>

                                                <v-progress-linear
                                                    v-if="load === true"
                                                    indeterminate
                                                    color="cyan"
                                                ></v-progress-linear>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                class="text-center"
                                                v-if="
                                                    state_chk.project_name ===
                                                        'CDAX' &&
                                                        form.status ===
                                                            'Incomplete'
                                                "
                                            >
                                                <v-radio-group
                                                    v-model="form.quotation"
                                                    :rules="quotationR"
                                                    required
                                                    row
                                                >
                                                    <v-radio
                                                        label="เสนอราคา"
                                                        value="Y"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ไม่เสนอราคา"
                                                        value="N"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>

                                            <v-col
                                                class="mar-t-10"
                                                cols="12"
                                                v-if="
                                                    form.show_ismart == 'Y' &&
                                                        form.status ===
                                                            'Complete'
                                                "
                                            >
                                                <v-combobox
                                                    :items="data_symptom"
                                                    v-model="form.ce_symptom"
                                                    label="อาการเสียที่พบ (ภาษาอังกฤษ)"
                                                    :rules="ce_symptomR"
                                                    dense
                                                    outlined
                                                ></v-combobox>
                                            </v-col>

                                            <v-col
                                                class="mar-t-10"
                                                cols="12"
                                                v-if="
                                                    form.show_ismart == 'Y' &&
                                                        form.status ===
                                                            'Incomplete'
                                                "
                                            >
                                                <v-autocomplete
                                                    dense
                                                    outlined
                                                    menu-props="auto"
                                                    label="Local Status"
                                                    :items="local_status_item"
                                                    v-model="form.local_status"
                                                    :rules="local_statusR"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col
                                                class="mar-t-10"
                                                cols="12"
                                                v-if="form.status != null"
                                            >
                                                <div
                                                    v-if="
                                                        form.show_ismart == 'Y'
                                                    "
                                                >
                                                    <v-combobox
                                                        :items="data_solution"
                                                        v-model="form.solution"
                                                        label="Solution.."
                                                        :rules="solutionR"
                                                        dense
                                                        outlined
                                                    ></v-combobox>
                                                </div>
                                                <div v-else>
                                                    <v-textarea
                                                        outlined
                                                        label="Solution"
                                                        v-model="form.solution"
                                                        :rules="
                                                            form.status ===
                                                            'Incomplete'
                                                                ? engineer_statusR2
                                                                : []
                                                        "
                                                    ></v-textarea>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close()"
                                >Close</v-btn
                            >

                            <v-btn
                                color="success"
                                @click="save_case()"
                                :disabled="!valid"
                                >Save</v-btn
                            >
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_ismart"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="close_view_ismart()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <ISmart
                        :data_ismart="data_ismart"
                        @close_page="close_view_ismart()"
                        :check_page="2"
                    />
                </v-card-text>

                <div style="flex: 1 1 auto"></div>
            </v-card>
        </v-dialog>

        <v-row justify="center">
            <v-dialog v-model="dialog_pickup" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Pickup Unit</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-radio-group
                                    v-model="form_pickup.status"
                                    column
                                >
                                    <v-radio
                                        label="เปิด sub ใหม่คืนเครื่องลูกค้า"
                                        value="sendcustomer"
                                    ></v-radio>
                                    <v-radio
                                        label=" เปิด sub ใหม่เบิก part เพิ่ม"
                                        value="addpart"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" class="mar-t-20">
                                <v-textarea
                                    outlined
                                    v-model="form_pickup.remark"
                                    label="Remark..."
                                    background-color="#FFFF"
                                    rows="4"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color=""
                            small
                            text
                            @click="dialog_pickup = false"
                            >Close</v-btn
                        >
                        <v-spacer></v-spacer>

                        <v-btn
                            :disabled="form_pickup.status === null"
                            color="success"
                            small
                            @click="save_pickup()"
                            ><v-icon small class="mr-1"
                                >mdi-content-save</v-icon
                            >
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- Add part case -->
        <v-row justify="center">
            <v-form method="post" id="nativeForm" v-model="valid_case_part">
                <v-dialog
                    v-model="dialog_app_part"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dense dark color="primary">
                            <v-btn
                                icon
                                dark
                                @click="close_dialog_app_part()"
                                :disabled="!valid_case_part"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>

                            <v-toolbar-title>
                                <v-row>
                                    <v-col cols="10">
                                        <b>Add Singlepart</b>
                                    </v-col>
                                </v-row>
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="10">
                                    <v-text-field
                                        outlined
                                        dense
                                        label="Singlepart"
                                        :maxlength="7"
                                        :counter="7"
                                        v-model="case_part.part"
                                        @input="
                                            checksinglepart_casepart(
                                                case_part.part
                                            )
                                        "
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        fab
                                        small
                                        :color="
                                            case_part.barcode == false
                                                ? ''
                                                : 'cyan'
                                        "
                                        @click="
                                            case_part.barcode = !case_part.barcode
                                        "
                                    >
                                        <v-icon>mdi-barcode-scan</v-icon>
                                    </v-btn>
                                </v-col>

                                <v-col
                                    cols="12"
                                    v-if="case_part.barcode == true"
                                >
                                    <StreamBarcodeReader
                                        @barcode="gen_barcode_add_part"
                                        :direction="direction"
                                    />
                                </v-col>
                            </v-row>

                            <div v-if="form_1.case_part.length > 0">
                                <v-row
                                    :class="
                                        index_case_part > 0 ? 'mar-t-25' : ''
                                    "
                                    v-for="(row_case_part,
                                    index_case_part) in form_1.case_part"
                                    :key="index_case_part"
                                >
                                    <v-col cols="4">
                                        <v-chip color="amber"
                                            >{{ index_case_part + 1 }}.{{
                                                row_case_part.singlepart
                                            }}</v-chip
                                        >
                                    </v-col>
                                    <v-col cols="6" class="mar-t-25">
                                        <v-select
                                            class="mt-6"
                                            dense
                                            outlined
                                            :items="part_item"
                                            item-text="text"
                                            item-value="id"
                                            label="Status part"
                                            v-model="row_case_part.status"
                                            required
                                            :rules="statusR2"
                                        ></v-select>
                                        <!-- :rules="part_issue_idR" -->
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn
                                            small
                                            fab
                                            color="red accent-2"
                                            @click="
                                                del_case_part(row_case_part)
                                            "
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-row>

        <!-- Snackbar -->
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { mapState, mapMutations } from "vuex"
import VueTimepicker from "vue2-timepicker/src"
import "vue2-timepicker/dist/VueTimepicker.css"
import VueUploadMultipleImage from "vue-upload-multiple-image"
import ISmart from "./ISmart.vue"
import resizebase64 from "resize-base64"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_menu()
    },
    created() {
        this.checksinglepart_srfr = _.debounce(this.checksinglepart_srfr, 300)
        this.checksinglepart_kbank = _.debounce(this.checksinglepart_kbank, 300)
    },
    components: { VueUploadMultipleImage, VueTimepicker, ISmart },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_menu() {
            await axios
                .get(url + "engineer/pending/get-menu", this.tk)
                .then((response) => {
                    this.active_tab = response.data[0]
                    this.tabs_name = response.data
                    this.get_data()
                })
        },
        async get_data() {
            if (this.tabs_name.length > 0) {
                this.mutateIsLoading()
                await axios
                    .get(
                        url + "engineer/pending/view/" + this.active_tab.title,
                        this.tk
                    )
                    .then((response) => {
                        this.data_main = response.data
                        console.log(response.data, 'check pending')
                        this.mutateIsLoading()

                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.$emit("homePage")
            }
        },
        change_tab(change_tab) {
            this.active_tab = change_tab
            this.get_data()
        },
        async change_case(
            maincase_id,
            chk,
            case_id,
            subcase,
            product_group,
            project_name,
            warranty_type,
            row
        ) {
            if (this.active_tab.title != "Incomplete") {
                this.show_case = case_id
                this.form.maincase_id = maincase_id
                this.product_group = product_group
                this.form_1.maincase_id = maincase_id
                this.form_1.subcase = subcase
                this.state_chk.project_name = project_name
                this.state_chk.warranty_type = warranty_type
                this.data_eeg = row
                // console.log(row)
                if (chk == "Waiting") {
                    this.search_symptom()
                    this.search_solution()

                    this.dialog_loading = true
                    await axios
                        .get(
                            `${url}engineer/waiting-customer/${this.form.maincase_id}`,
                            this.tk
                        )
                        .then((response) => {
                            this.form.ce_symptom = response.data.ce_symptom
                            this.form.solution = response.data.solution
                            this.form.show_ismart = response.data.show_ismart

                            this.dialog_loading = false
                            this.dialog = true
                        })
                        .catch(function(error) {
                            console.log(error)
                        })
                } else {
                    this.dialogCloseCase = true
                    this.mutateIsLoading()
                    await axios
                        .get(url + "engineer/rejected-case/" + maincase_id)
                        .then((response) => {
                            let st = response.data[0].start.split(":")
                            let en = response.data[0].stop.split(":")
                            this.form_1.start = {
                                HH: st[0],
                                mm: st[1],
                            }
                            this.form_1.stop = {
                                HH: en[0],
                                mm: en[1],
                            }
                            this.form_1.csono = response.data[0].csono
                            this.form_1.solution = response.data[0].solution
                            this.form_1.email = response.data[0].email
                            this.data_close_case = response.data
                            this.chk_img_old.cso = this.data_close_case[0].cso.length
                            this.chk_img_old.attach = this.data_close_case[0].attach.length
                            this.data_close_case[0].parts.map((each, index) => {
                                this.form_1.part["P" + each.part_issue_id] =
                                    each.ce_status
                            })
                            this.case_team_name = response.data[0].team_name
                            // console.log(this.data_close_case)
                            this.mutateIsLoading()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            }
        },
        close() {
            this.form = {
                maincase_id: 0,
                status: null,
                customer_level: "",
                uefi_text: "",
                ce_symptom: "",
                solution: "",
                show_ismart: "",
                remark: "",
            }
            this.dialog = false
        },
        back() {
            this.dialogCloseCase = false
        },
        async checksinglepart_srfr() {
            let { data } = await axios.post(
                url + "engineer/srfr/checksinglepart"
            )
        },
        async checksinglepart_kbank() {
            let { data } = await axios.post(
                url + "engineer/kbank/checksinglepart"
            )
        },
        uploadImageSuccess(formData, index, fileList) {
            this.form_1.cso = fileList
        },
        beforeRemove(index, done, fileList) {
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage(formData, index, fileList) {},
        uploadImageSuccess2(formData, index, fileList) {
            this.form_1.uefi = fileList
        },
        beforeRemove2(index, done, fileList) {
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage2(formData, index, fileList) {},
        uploadImageSuccess3(formData, index, fileList) {
            this.form_1.attach = fileList
        },
        beforeRemove3(index, done, fileList) {
            var r = confirm("remove image")
            if (r == true) {
                done()
            } else {
            }
        },
        editImage3(formData, index, fileList) {},
        async save_case() {
            if (this.form.customer_level === "") {
                if (this.form.status === "Complete") {
                    this.chk_customer_level = true
                    this.dialog_loading = true
                }
            }

            // if (
            //     this.form.status == "Incomplete" &&
            //     this.form.show_ismart == "Y"
            // ) {
            //     this.dialog_loading = true
            //     let datax2
            //     let date = new Date()
            //     var h = date.getHours()
            //     var m = date.getMinutes()
            //     var s = date.getSeconds()
            //     let year = date.toLocaleString("default", {
            //         year: "numeric",
            //     })
            //     let month = date.toLocaleString("default", {
            //         month: "2-digit",
            //     })
            //     let day = date.toLocaleString("default", { day: "2-digit" })
            //     let formattedDate =
            //         year +
            //         "-" +
            //         month +
            //         "-" +
            //         day +
            //         "T" +
            //         h +
            //         ":" +
            //         m +
            //         ":" +
            //         s +
            //         "Z"
            //     let Note_Update_All = {
            //         CaseExchange: {
            //             EventType: "PartnerUpdates",
            //             EventSubType: "Updates",
            //             Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
            //             IncomingChannel: "EEG",
            //             WorkOrder: {
            //                 WorkOrderID: this.data_eeg.wonumber,
            //                 PartnerName: "APJ_Acacia_P",
            //                 PartnerStatusDateTime: formattedDate,
            //             },
            //             Notes: {
            //                 NotesDescription: `$#${this.form.local_status}#$`,
            //                 ExternallyVisible: "Yes",
            //             },
            //             Attachment: {
            //                 FileType: null,
            //                 FileName: null,
            //                 FileContent: null,
            //             },
            //         },
            //     }
            //     datax2 = {
            //         Note_Update_All: Note_Update_All,
            //     }
            //     this.form.eeg2 = datax2
            //     this.form.project_name = this.data_eeg.project_name
            // }

            // console.log(this.form, "-save")

            await axios
                .post(url + "engineer/waiting-customer", this.form, this.tk)
                .then((response) => {
                    if (response.data.show_ismart == "Y") {
                        this.form = {
                            maincase_id: 0,
                            status: null,
                            customer_level: "",
                            uefi_text: "",
                            ce_symptom: "",
                            solution: "",
                            show_ismart: "",
                            remark: "",
                            project_name: "",
                            eeg2: {},
                        }
                        this.data_eeg = []
                        this.dialog = false
                        this.dialog_loading = false
                        this.view_ismart(response.data.subcase_id)
                    } else {
                        this.dialog_loading = false
                        this.close()
                        this.get_data()
                    }

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async save_close_case() {
            let chk_save = false

            if (this.form_1.cso.length == 0 && this.chk_img_old.cso == 0) {
                this.chk_cso = true
            } else if (
                this.form_1.attach.length === 0 &&
                this.chk_img_old.attach == 0 &&
                this.product_group === "Printing"
            ) {
                this.chk_cso = false
                this.chk_attach = true
            } else {
                this.chk_cso = false
                this.chk_attach = false
            }

            if (!this.chk_cso && !this.chk_attach) {
                chk_save = true
            }
            // console.log(chk_save)

            if (chk_save === true) {
                this.chk_save_data = true

                this.form_1.start =
                    this.form_1.start["HH"] + ":" + this.form_1.start["mm"]
                this.form_1.stop =
                    this.form_1.stop["HH"] + ":" + this.form_1.stop["mm"]
                let formData = new FormData()
                formData.append("start", this.form_1.start)
                formData.append("stop", this.form_1.stop)
                formData.append("part", JSON.stringify(this.form_1.part))
                formData.append("csono", this.form_1.csono)
                formData.append("maincase_id", this.form_1.maincase_id)
                formData.append("subcase", this.form_1.subcase)
                formData.append("email", this.form_1.email)
                formData.append("solution", this.form_1.solution)
                formData.append(
                    "case_part",
                    JSON.stringify(this.form_1.case_part)
                )
                if (undefined !== this.form_1.singlepart_black) {
                    formData.append(
                        "singlepart_black",
                        this.form_1.singlepart_black
                    )
                }
                if (undefined !== this.form_1.singlepart_color) {
                    formData.append(
                        "singlepart_color",
                        this.form_1.singlepart_color
                    )
                }
                if (undefined !== this.form_1.singlepart) {
                    formData.append("singlepart", this.form_1.singlepart)
                }
                if (undefined !== this.form_1.sn) {
                    formData.append("sn", this.form_1.sn)
                }
                if (undefined !== this.form_1.persend) {
                    formData.append("persend", this.form_1.persend)
                }
                if (undefined !== this.form_1.page_remaining) {
                    formData.append(
                        "page_remaining",
                        this.form_1.page_remaining
                    )
                }
                if (undefined !== this.form_1.page_printer) {
                    formData.append("page_printer", this.form_1.page_printer)
                }
                if (undefined !== this.form_1.cso && this.form_1.cso.length) {
                    for (let i = 0; i < this.form_1.cso.length; i++) {
                        let img_cso = resizebase64(
                            this.form_1.cso[i].path,
                            1000,
                            1000
                        )
                        formData.append(`cso[${i}]`, img_cso)
                    }
                }
                if (undefined !== this.form_1.uefi && this.form_1.uefi.length) {
                    for (let i = 0; i < this.form_1.uefi.length; i++) {
                        let img_uefi = resizebase64(
                            this.form_1.uefi[i].path,
                            750,
                            750
                        )
                        formData.append(`uefi[${i}]`, img_uefi)
                    }
                }
                if (
                    undefined !== this.form_1.attach &&
                    this.form_1.attach.length
                ) {
                    let size_attach = 0
                    this.state_chk.project_name == "MPS"
                        ? (size_attach = 1000)
                        : (size_attach = 750)
                    for (let i = 0; i < this.form_1.attach.length; i++) {
                        let img_attach = resizebase64(
                            this.form_1.attach[i].path,
                            size_attach,
                            size_attach
                        )
                        formData.append(`attach[${i}]`, img_attach)
                    }
                }

                await axios
                    .post(url + "engineer/rejected-case", formData, this.tk)
                    .then((response) => {
                        this.chk_save_data = false
                        this.mutatesnackbar()
                        this.engineer_status = ""
                        this.form_1.part = []
                        this.form_1.start = []
                        this.form_1.stop = []
                        this.form_1.csono = ""
                        this.form_1.cso = []
                        this.form_1.uefi = []
                        this.form_1.maincase_id = ""
                        // this.form_1.subcase = ""
                        this.form_1.email = ""
                        this.form_1.solution = ""
                        this.chk_cso = false
                        //case part
                        this.form_1.case_part = []
                        this.case_part.part = ""
                        this.case_part.barcode = false
                        this.chk_attach = false
                        this.get_menu()
                        this.back()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
            }
        },
        async save_close_case_img() {
            this.mutateIsLoading()
            this.chk_save_data = true
            let formData = new FormData()
            formData.append("maincase_id", this.form_1.maincase_id)
            formData.append("subcase", this.form_1.subcase)
            if (undefined !== this.form_1.cso && this.form_1.cso.length) {
                for (let i = 0; i < this.form_1.cso.length; i++) {
                    formData.append(`cso[${i}]`, this.form_1.cso[i].path)
                }
            }
            if (undefined !== this.form_1.uefi && this.form_1.uefi.length) {
                for (let i = 0; i < this.form_1.uefi.length; i++) {
                    formData.append(`uefi[${i}]`, this.form_1.uefi[i].path)
                }
            }
            if (undefined !== this.form_1.attach && this.form_1.attach.length) {
                for (let i = 0; i < this.form_1.attach.length; i++) {
                    formData.append(`attach[${i}]`, this.form_1.attach[i].path)
                }
            }
            await axios
                .post(url + "engineer/upload-more", formData, this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.chk_save_data = false

                    this.mutatesnackbar()
                    this.form_1.maincase_id = ""
                    this.form_1.cso = []
                    this.form_1.uefi = []
                    this.chk_cso = false
                    this.chk_attach = false
                    this.get_menu()
                    this.back()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch(function(error) {
                    console.log(error, "-- upload img error")
                })
        },
        show() {
            const viewer = this.$el.querySelector(".images").$viewer
            viewer.show()
        },
        del_img(types, id) {
            this.$swal({
                title: "ต้องการลบรูป " + types + " ใช้หรือไม่",
                text: "",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((del) => {
                if (del) {
                    axios
                        .delete(url + "case/attachments/" + id)
                        .then((response) => {
                            this.change_case(
                                this.form_1.maincase_id,
                                this.active_tab,
                                this.show_case,
                                this.form_1.subcase,
                                this.product_group,
                                this.state_chk.project_name,
                                this.state_chk.warranty_type,
                                this.data_eeg
                            )
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        cick_cus(c) {
            this.form.customer_level = c
        },
        async checkuefi_text() {
            if (this.form.uefi === "Y" && this.form.uefi_text.length === 27) {
                this.load = true
                await axios
                    .post(
                        "https://eas-api.hpcloud.hp.com/v1/DecodeFailureIds/",
                        {
                            LanguageId: "en-US",
                            FailureIds: [
                                {
                                    FailureId: this.form.uefi_text,
                                },
                            ],
                        }
                    )
                    .then((response) => {
                        this.load = false
                        if (response.data.DecodeFailureIds[0].Valid === false) {
                            this.form.uefi_text = ""
                            this.$swal("uefi invalid! Please try again.", {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        } else if (
                            response.data.DecodeFailureIds[0].Valid === true
                        ) {
                            this.$swal("uefi Valid.", {
                                icon: "success",
                                button: false,
                                timer: 2000,
                            })
                        }
                    })
            }
        },
        dataChange() {},
        dataChange2() {},
        dataChange3() {},
        change_case_picup(maincase_id) {
            this.dialog_pickup = true
            this.form_pickup.maincase_id = maincase_id
        },
        async save_pickup() {
            this.mutateIsLoading()
            await axios
                .post(
                    url + "return-to-customer/" + this.form_pickup.maincase_id,
                    this.form_pickup,
                    this.tk
                )
                .then((response) => {
                    this.mutateIsLoading()
                    this.form_pickup.maincase_id = 0
                    this.form_pickup.status = null
                    this.form_pickup.remark = null
                    this.mutatesnackbar()
                    this.get_menu()
                    this.dialog_pickup = false

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        uppercase(d) {
            if (d == 1) {
                this.form_1.solution = this.form_1.solution.toUpperCase()
            } else if (d == 2) {
                this.form.solution = this.form.solution.toUpperCase()
            }
        },
        open_add_part() {
            this.dialog_app_part = true
        },
        close_dialog_app_part() {
            this.dialog_app_part = false
        },
        async checksinglepart_casepart() {
            if (this.case_part.part.length === 7) {
                let data_chk = {
                    singlepart: this.case_part.part,
                }

                let chk = false
                await axios
                    .post(
                        url + "engineer/check-singlepart-more",
                        data_chk,
                        this.tk
                    )
                    .then((response) => {
                        if (response.data.status === "OK") {
                            if (this.form_1.case_part.length >= 1) {
                                this.form_1.case_part.map((each, index) => {
                                    if (
                                        each.singlepart !=
                                        response.data.part.singlepart
                                    ) {
                                        chk = true
                                        this.$swal(
                                            "Singlepart Valid," +
                                                response.data.detail,
                                            {
                                                icon: "success",
                                                button: false,
                                                timer: 2000,
                                            }
                                        )
                                    } else {
                                        chk = false
                                        this.$swal("Singlepart ซ้ำ", {
                                            icon: "warning",
                                            button: false,
                                            timer: 2000,
                                        })
                                    }
                                })
                            } else {
                                chk = true

                                this.$swal(
                                    "Singlepart Valid," + response.data.detail,
                                    {
                                        icon: "success",
                                        button: false,
                                        timer: 2000,
                                    }
                                )
                            }

                            this.case_part.part = ""
                        } else {
                            chk = false
                            this.case_part.part = ""
                            this.$swal(response.data.detail, {
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })
                        }
                        if (chk == true) {
                            this.form_1.case_part.push(response.data.part)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                    })
            }
        },
        async gen_barcode_add_part(result) {
            this.case_part.part = result
            this.checksinglepart_casepart()
        },
        del_case_part(n) {
            const filteredItems = this.form_1.case_part.filter(
                (item) => item !== n
            )
            this.form_1.case_part = filteredItems
        },
        async search_symptom() {
            let send = {
                maincase_id: this.form.maincase_id,
            }
            this.dialog_loading = true
            await axios
                .post(url + "engineer/search-symptom", send, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_symptom = response.data
                    // console.log(response, "search-symptom")
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        async search_solution() {
            let send = {
                maincase_id: this.form.maincase_id,
            }
            this.dialog_loading = true
            await axios
                .post(url + "engineer/search-solution", send, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_solution = response.data
                    // console.log(response, "search-solution")
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        view_ismart(subcase_id) {
            this.data_ismart = subcase_id
            this.dialog_ismart = true
        },
        close_view_ismart(subcase_id) {
            this.data_ismart = ""
            this.dialog_ismart = false
            this.get_menu()
        },
    },
    data() {
        return {
            data_eeg: [],
            dialog_ismart: false,
            data_ismart: "",
            dialog_loading: false,
            data_symptom: [],
            data_solution: [],
            valid_case_part: false,
            case_part: {
                part: "",
                barcode: false,
            },
            dialog_app_part: false,
            case_team_name: "",
            product_group: null,
            chk_save_data: false,
            team_name: localStorage.team_name,
            status_color: ["indigo lighten-3", "success", "amber"],
            chk_customer_level: false,
            dialog: false,
            dialog_pickup: false,
            dialogCloseCase: false,
            valid: false,
            data_main: [],
            data_close_case: [],
            tab: false,
            active_tab: "",
            tabs_name: [],
            show_case: "",
            load: false,
            state_chk: {
                project_name: null,
                warranty_type: null,
            },
            form: {
                maincase_id: 0,
                status: null,
                customer_level: "",
                uefi_text: "",
                ce_symptom: "",
                solution: "",
                show_ismart: "",
                eeg2: {},
            },
            form_1: {
                csono: "",
                solution: "",
                email: "",
                part: {},
                start: [],
                stop: [],
                cso: [],
                uefi: [],
                attach: [],
                maincase_id: "",
                subcase: null,
                case_part: [],
            },
            form_pickup: {
                maincase_id: 0,
                status: null,
                remark: null,
            },
            chk_cso: false,
            chk_attach: false,
            chk_img_old: {
                cso: 0,
                attach: 0,
            },
            text: "Success, Your work has been saved",
            statusR2: [(v) => !!v || "Status is required"],
            statusR: [(v) => !!v || "Engineer Status is required"],
            engineer_statusR2: [(v) => !!v || "Engineer Status is required"],
            engineer_statusR: [(v) => !!v || "Engineer Status is required"],
            myIdUpload1: [(v) => !!v || "Cso is required"],
            part_issue_idR: [(v) => !!v || "Part is required"],
            startR: [(v) => !!v || "Start is required"],
            stopR: [(v) => !!v || "Stop is required"],
            csonoR: [(v) => !!v || "Csono is required"],
            solutionR: [(v) => !!v || "Solution is required"],
            RemarkR: [(v) => !!v || "Remark is required"],
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/case/attachments/`,
            tk: "",
            quotationR: [(v) => !!v || "quotation Status is required"],
            uefiR: [(v) => !!v || "UEFI Status is required"],
            uefi_textR: [
                (v) => !!v || "UEFI Text is required",
                (v) =>
                    v.length === 27 || "UEFI must be less than 27 characters",
            ],
            uefi_textRR: [(v) => !!v || "UEFI Remark  is required"],
            ce_symptomR: [(v) => !!v || "โปรดระบุอาการเสียที่พบ (ภาษาอังกฤษ)"],
            local_statusR: [(v) => !!v || "Local Status  is required"],
            local_status_item: [
                "Part need to order",
                "Additional Part",
                "Part Backorder",
                "Additional Part - Part Damage",
                "Additional Part - Wrong part Ordered",
                "Additional Part - Wrong part Shipped",
                "Elevation - HP Pending",
                "Rework Trade -OTC to be changed",
                "Trade -PO/Payment awaited",
                "Trade -Price Awaited",
                "Trade -QI (Quote To Be Share)",
                "Trade - Quote Approved",
                "Trade - Quote Cancelled",
                "Trade - Quote Generated",
                "CRT - Open",
            ],
            local_status: "",
            part_item: [
                {
                    id: "Bad",
                    text: "ใช้ Part (73)",
                },
                {
                    id: "Good",
                    text: "ไม่ใช้ Part (72)",
                },
                {
                    id: "DOA",
                    text: "Part เสีย ทำคืน DOA (55)",
                },
                {
                    id: "Same Item",
                    text: "วาง Spare / Same Item",
                },
                {
                    id: "Pending",
                    text: "ยังไม่คืน Part ถือไว้ใช้ในซับต่อไป",
                },
                {
                    id: "Install",
                    text: "ติดตั้งถาวร",
                },
            ],
            part_backorder_item: [
                {
                    id: "Cancel",
                    text: "ไม่ใช้ Part",
                },
                {
                    id: "Pending",
                    text: "ต้องใช้ Part / รอ Part",
                },
            ],
        }
    },
}
</script>
<style scoped>
.image-cso {
    height: 100px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
.image-cso-btn {
    margin-top: -10px !important;
    margin-left: -18px !important;
}
.fix-png-a {
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 20px;
}
</style>
